import Resume from './Resume';
import './App.css';

function App() {
  return (
    <Resume />
  );
}

export default App;
